module.exports = "/_next/static/images/a1f0ab36dac6f8f68f2b9937717843ed-nuconta-inclined-device@0.75x.png.webp";